import {AdsTxtStatus} from './adstxt-status.model';
import {KeyLabel} from './key-label.model';
export class DomainDpApproval {
  id: DomainDpApprovalId;
  status: DomainDpStatus;
  adsTxtCondensedStatus: AdsTxtStatus;
  adsTxtCondensedRequiredRecords: number;
  adsTxtCondensedMissingRecords: number;
  adsTxtStatus: AdsTxtStatus;
  adsTxtRequiredRecords: number;
  adsTxtMissingRecords: number;
  publisherSalesRep: string;
  createdOn: string;
  submitted: boolean;
  submittedDate: string;
  lastUpdatedOn: string;
}

export class DomainDpApprovalId {
  url: string;
  demandPartner: string;
}

export enum DomainDpStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export const DomainDpStatusLabels = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  REJECTED: 'Rejected'
};

export const DomainDpStatusKL = () => Object.keys(DomainDpStatus).map(key => new KeyLabel(key, DomainDpStatusLabels[key]));
